if (!customElements.get('ws-customer-feedback')) {
  customElements.define('ws-customer-feedback', class extends HTMLElement {
    connectedCallback() {
      this.frames = new Map();
      this.counters = Array.from(this.querySelectorAll('[data-counter]'));
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => { if (this.motion.matches) this.finish(); };
      this.motion.addEventListener('change', this.onMotionChange);
      if (this.dataset.animate !== 'true' || this.motion.matches || !('IntersectionObserver' in window)) {
        this.finish();
        return;
      }
      const duration = Math.max(100, Number(this.dataset.duration) || 1600);
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const counter = entry.target;
          this.observer.unobserve(counter);
          const target = Number(counter.dataset.value);
          let start;
          const tick = now => {
            if (start === undefined) start = now;
            const progress = Math.min((now - start) / duration, 1);
            counter.textContent = String(Math.round(target * (1 - Math.pow(1 - progress, 3))));
            if (progress < 1) this.frames.set(counter, requestAnimationFrame(tick));
            else this.frames.delete(counter);
          };
          this.frames.set(counter, requestAnimationFrame(tick));
        });
      }, { threshold: 0.5 });
      this.counters.forEach(counter => {
        counter.textContent = '0';
        this.observer.observe(counter);
      });
    }
    finish() {
      this.observer?.disconnect();
      this.frames.forEach(frame => cancelAnimationFrame(frame));
      this.frames.clear();
      this.counters.forEach(counter => { counter.textContent = counter.dataset.value; });
    }
    disconnectedCallback() {
      this.finish();
      this.motion.removeEventListener('change', this.onMotionChange);
    }
  });
}
